import React, { useEffect, useState } from "react";
import ComponentCustomModal from "../../components/common/customModal/ComponentCustomModal";
import { useTranslation } from "react-i18next";
import { getRoutersMacVendors } from "../../features/apiCalls";
import { useDispatch, useSelector } from "react-redux";

const MacVendor = ({ show, setShow, customer }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const macVendor = useSelector((state) => state.mikrotik?.macVendor);

  const [isLoading, setIsLoading] = useState(false);

  const vendorFields = [
    { label: t("macAddress"), key: "macAddress" },
    { label: t("company"), key: "company" },
  ];

  useEffect(() => {
    if (customer?.callerId) {
      getRoutersMacVendors(dispatch, customer?.callerId, setIsLoading);
    }
  }, [customer]);

  return (
    <ComponentCustomModal
      {...{
        show,
        setShow,
        centered: true,
        size: "md",
        header: customer?.pppoe?.name
          ? customer?.pppoe?.name + " " + t("macAddress") + " " + t("vendor")
          : customer?.name + " " + t("macAddress") + " " + t("vendor"),
      }}
    >
      <div>
        {isLoading
          ? vendorFields.map((field, index) => (
              <div
                className="displayGridManual7_3 placeholder-glow"
                key={index}
              >
                <p>{field.label}</p>
                <p className="placeholder rounded-pill"></p>
              </div>
            ))
          : vendorFields.map(
              (field, index) =>
                macVendor?.[field.key] && (
                  <div
                    className="displayGridManual7_3 macVendorText"
                    key={index}
                  >
                    <p>{field.label}</p>
                    <p>{macVendor?.[field.key]}</p>
                  </div>
                ),
            )}
      </div>
    </ComponentCustomModal>
  );
};

export default MacVendor;
